const config = {
  vuexStorageKeys: [
    'sessionToken',
    'user'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'user',
    'index',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 light
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: '佳彩化工',
  apiUrl: 'https://cloud.jiacai.mokekeji.com',
  // apiUrl: 'http://192.168.50.241:3333',
  appID: 'x9Xsw4wScaWuX1lrNDDPK6OWeX6dWQHz',
  masterKey: 'RpIqEGQR3ht9l2NtJU7lB4PFIz230tLr',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
